import qs from 'qs';
import { useQuery } from 'react-query';

import { axios } from 'lib';

export const getRelatedDirects = async (companyID, queryStringParams) => {
  const queryString = qs.stringify({ ...queryStringParams });

  const {
    data: { data: directs, total },
  } = await axios.get(`/api/companies/${companyID}/directs?${queryString}`);

  return { directs, total };
};

const defaultQueryParams = {
  page: 0,
  limit: 10,
  search: '',
  includeInactive: false,
  acceptingOffers: true,
  sortBy: 'dateCreated',
};

export const useGetRelatedDirects = (companyID, queryParams) => {
  const { page, limit, search, includeInactive, acceptingOffers, sortBy, queryOptions } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  return useQuery(
    ['related-directs', companyID, page, limit, search, includeInactive, acceptingOffers, sortBy],
    () =>
      getRelatedDirects(companyID, {
        page,
        limit,
        search,
        includeInactive,
        acceptingOffers,
        sortBy,
      }),
    queryOptions
  );
};
